(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["accordion-section"] && !window.DesignMode) return;
  try {
    
  if(('.first-open').length > 0) {
   $('.shopify_explorer_faq__answer').eq(0).fadeIn();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-landing"] && !window.DesignMode) return;
  try {
    

  if ($('.blog-menu').length > 0) {

    var loadedClass = $('.blog-menu li').attr('class');
    $('.blog-menu li').eq(0).addClass('active');      

    $('.blogs-grid .blog-block').each(function() {

        var crrnt = $(this);

        if (crrnt.hasClass(loadedClass)) {
            crrnt.addClass('show');
        }

        else {
            crrnt.removeClass('show');
        }
    });	

    $('.blog-menu li').on('click', function() {

        if (!$(this).hasClass('active')) {
            var clickedClass = $(this).attr('class');
            $('.blog-menu li').removeClass('active');
            $(this).toggleClass('active');


            $('.blogs-grid .blog-block').each(function() {
                var crrnt = $(this);

                if (crrnt.hasClass(clickedClass)) {
                    crrnt.addClass('show');
                }

                else {
                    crrnt.removeClass('show');
                }
            });	
        }
    });
  }


  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-care"] && !window.DesignMode) return;
  try {
    


if ($('.customer-care-menu').length > 0) {
    
    var loadedClass = $('.customer-care-menu li').attr('class');
    $('.customer-care-menu li').eq(0).addClass('active');      

    $('.customer-care .right .menu-section').each(function() {

        var crrnt = $(this);

        if (crrnt.hasClass(loadedClass)) {
            crrnt.addClass('show');
        }

        else {
            crrnt.removeClass('show');
        }
    });	

    $('.customer-care-menu li').on('click', function() {

        if (!$(this).hasClass('active')) {
            var clickedClass = $(this).attr('class');
            $('.customer-care-menu li').removeClass('active');
            $(this).toggleClass('active');


            $('.customer-care .right .menu-section').each(function() {
                var crrnt = $(this);

                if (crrnt.hasClass(clickedClass)) {
                    crrnt.addClass('show');
                }

                else {
                    crrnt.removeClass('show');
                }
            });	
        }
    });
  }



  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["get-the-look"] && !window.DesignMode) return;
  try {
    
  
if ($('.get-the-look').length > 0) {

  if ($('.img-side').length > 0) {

    var loadedClass = $('.img-side ul li').attr('class');
    $('.img-side ul li').eq(0).addClass('active');      

    $('.ff-content-side .single-product').each(function() {

        var crrnt = $(this);

        if (crrnt.hasClass(loadedClass)) {
            crrnt.addClass('show');
        }

        else {
            crrnt.removeClass('show');
        }
    });	

    $('.img-side ul li').on('click', function() {

        if (!$(this).hasClass('active')) {
            var clickedClass = $(this).attr('class');
            $('.img-side ul li').removeClass('active');
            $(this).toggleClass('active');


            $('.ff-content-side .single-product').each(function() {
                var crrnt = $(this);

                if (crrnt.hasClass(clickedClass)) {
                    crrnt.addClass('show');
                }

                else {
                    crrnt.removeClass('show');
                }
            });	
        }
    });
  }
}

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    

 

  if ($('.blog-menu').length > 0) {

    var loadedClass = $('.blog-menu li').attr('class');
    $('.blog-menu li').eq(0).addClass('active');      

    $('.blog-block').each(function() {

        var crrnt = $(this);

        if (crrnt.hasClass(loadedClass)) {
            crrnt.addClass('show');
        }

        else {
            crrnt.removeClass('show');
        }
    });	

    $('.blog-menu li').on('click', function() {

        if (!$(this).hasClass('active')) {
            var clickedClass = $(this).attr('class');
            $('.blog-menu li').removeClass('active');
            $(this).toggleClass('active');


            $('.blog-block').each(function() {
                var crrnt = $(this);

                if (crrnt.hasClass(clickedClass)) {
                    crrnt.addClass('show');
                }

                else {
                    crrnt.removeClass('show');
                }
            });	
        }
    });
  }



  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    

  $('.mobile-filter').on('click', function() {

          $('.mobile-shoppe-menu').addClass('active');

    });

  $('.mobile-menu-close').on('click', function() {

          $('.mobile-shoppe-menu').removeClass('active');

    });

  $('.mobile-shop li').on('click', function() {

var clickedClass = $(this).attr('class');

            $('.childlinks-wrapper').each(function() {
                var crrnt = $(this);

                if (crrnt.hasClass(clickedClass)) {
                    crrnt.toggleClass('show');
                }

                else {
                    crrnt.removeClass('show');
                }
            });	
        
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

if ($('.custom-details-wrapper').length > 0) {
    
    var loadedClass = $('.details-menu ul li').attr('class');
    $('.details-menu ul li').eq(0).addClass('active');      

    $('.custom-content').each(function() {

        var crrnt = $(this);

        if (crrnt.hasClass(loadedClass)) {
            crrnt.addClass('show');
        }

        else {
            crrnt.removeClass('show');
        }
    });	

    $('.details-menu ul li').on('click', function() {

        if (!$(this).hasClass('active')) {
            var clickedClass = $(this).attr('class');
            $('.details-menu ul li').removeClass('active');
            $(this).toggleClass('active');


            $('.custom-content').each(function() {
                var crrnt = $(this);

                if (crrnt.hasClass(clickedClass)) {
                    crrnt.addClass('show');
                }

                else {
                    crrnt.removeClass('show');
                }
            });	
        }
    });
  }

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfolio-slider"] && !window.DesignMode) return;
  try {
    
$(window).on('load', function() {

  // duration of scroll animation
  var scrollDuration = 300;
  // paddles
  var leftPaddle = document.getElementsByClassName('left-paddle');
  var rightPaddle = document.getElementsByClassName('right-paddle');
  // get items dimensions
  var itemsLength = $('.item').length;
  var itemSize = $('.item').outerWidth(true);
  // get some relevant size for the paddle triggering point
  var paddleMargin = 20;
  
  // get wrapper width
  var getMenuWrapperSize = function() {
    return $('.menu-wrapper').outerWidth();
  }
  var menuWrapperSize = getMenuWrapperSize();
  // the wrapper is responsive
  $(window).on('resize', function() {
    menuWrapperSize = getMenuWrapperSize();
  });
  // size of the visible part of the menu is equal as the wrapper size 
  var menuVisibleSize = menuWrapperSize;
  
  // get total width of all menu items
  var getMenuSize = function() {
    return itemsLength * itemSize;
  };
  var menuSize = getMenuSize();
  // get how much of menu is invisible
  var menuInvisibleSize = menuSize - menuWrapperSize;
  
  // get how much have we scrolled to the left
  var getMenuPosition = function() {
    return $('.menu').scrollLeft();
  };
  
  // finally, what happens when we are actually scrolling the menu
  $('.menu').on('scroll', function() {
  
    // get how much of menu is invisible
    menuInvisibleSize = menuSize - menuWrapperSize;
    // get how much have we scrolled so far
    var menuPosition = getMenuPosition();
  
    var menuEndOffset = menuInvisibleSize - paddleMargin;
  
    // // show & hide the paddles 
    // // depending on scroll position
   if (menuPosition <= paddleMargin) {
   $(leftPaddle).addClass('hidden');
   $(rightPaddle).removeClass('hidden');
    } else if (menuPosition < menuEndOffset) {
    //   // show both paddles in the middle
     $(leftPaddle).removeClass('hidden');
    $(rightPaddle).removeClass('hidden');
     } else if (menuPosition >= menuEndOffset) {
    $(leftPaddle).removeClass('hidden');
  //  $(rightPaddle).addClass('hidden');
    }
  
    // print important values
    $('#print-wrapper-size span').text(menuWrapperSize);
    $('#print-menu-size span').text(menuSize);
    $('#print-menu-invisible-size span').text(menuInvisibleSize);
    $('#print-menu-position span').text(menuPosition);
  
  });
  
  // scroll to left
  $(rightPaddle).on('click', function() {
    $('.menu').animate({
      scrollLeft: getMenuPosition() + ($('.menu').width()/2)
    }, scrollDuration);
  });
  
  // scroll to right
  $(leftPaddle).on('click', function() {
  
    $('.menu').animate({
      scrollLeft: getMenuPosition() - ($('.menu').width()/2)
    }, scrollDuration);
  });

  });


  




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["privacy-policy"] && !window.DesignMode) return;
  try {
    


if ($('.customer-care-menu').length > 0) {
    
    var loadedClass = $('.customer-care-menu li').attr('class');
    $('.customer-care-menu li').eq(0).addClass('active');      

    $('.customer-care .right .menu-section').each(function() {

        var crrnt = $(this);

        if (crrnt.hasClass(loadedClass)) {
            crrnt.addClass('show');
        }

        else {
            crrnt.removeClass('show');
        }
    });	

    $('.customer-care-menu li').on('click', function() {

        if (!$(this).hasClass('active')) {
            var clickedClass = $(this).attr('class');
            $('.customer-care-menu li').removeClass('active');
            $(this).toggleClass('active');


            $('.customer-care .right .menu-section').each(function() {
                var crrnt = $(this);

                if (crrnt.hasClass(clickedClass)) {
                    crrnt.addClass('show');
                }

                else {
                    crrnt.removeClass('show');
                }
            });	
        }
    });
  }



  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-product-slider"] && !window.DesignMode) return;
  try {
    

$(window).on('load', function() {

  // duration of scroll animation
  var scrollDuration = 300;
  // paddles
  var leftPaddle = document.getElementsByClassName('left-paddle');
  var rightPaddle = document.getElementsByClassName('right-paddle');
  // get items dimensions
  var itemsLength = $('.item').length;
  var itemSize = $('.item').outerWidth(true);
  // get some relevant size for the paddle triggering point
  var paddleMargin = 20;
  
  // get wrapper width
  var getMenuWrapperSize = function() {
    return $('.menu-wrapper').outerWidth();
  }
  var menuWrapperSize = getMenuWrapperSize();
  // the wrapper is responsive
  $(window).on('resize', function() {
    menuWrapperSize = getMenuWrapperSize();
  });
  // size of the visible part of the menu is equal as the wrapper size 
  var menuVisibleSize = menuWrapperSize;
  
  // get total width of all menu items
  var getMenuSize = function() {
    return itemsLength * itemSize;
  };
  var menuSize = getMenuSize();
  // get how much of menu is invisible
  var menuInvisibleSize = menuSize - menuWrapperSize;
  
  // get how much have we scrolled to the left
  var getMenuPosition = function() {
    return $('.menu').scrollLeft();
  };
  
  // finally, what happens when we are actually scrolling the menu
  $('.menu').on('scroll', function() {
  
    // get how much of menu is invisible
    menuInvisibleSize = menuSize - menuWrapperSize;
    // get how much have we scrolled so far
    var menuPosition = getMenuPosition();
  
    var menuEndOffset = menuInvisibleSize - paddleMargin;
  
    // // show & hide the paddles 
    // // depending on scroll position
   if (menuPosition <= paddleMargin) {
   // $(leftPaddle).addClass('hidden');
   $(rightPaddle).removeClass('hidden');
    } else if (menuPosition < menuEndOffset) {
    //   // show both paddles in the middle
     $(leftPaddle).removeClass('hidden');
    $(rightPaddle).removeClass('hidden');
     } else if (menuPosition >= menuEndOffset) {
    $(leftPaddle).removeClass('hidden');
  //  $(rightPaddle).addClass('hidden');
    }
  
    // print important values
    $('#print-wrapper-size span').text(menuWrapperSize);
    $('#print-menu-size span').text(menuSize);
    $('#print-menu-invisible-size span').text(menuInvisibleSize);
    $('#print-menu-position span').text(menuPosition);
  
  });
  
  // scroll to left
  $(rightPaddle).on('click', function() {
    $('.menu').animate({
      scrollLeft: getMenuPosition() + ($('.menu').width()/2)
    }, scrollDuration);
  });
  
  // scroll to right
  $(leftPaddle).on('click', function() {
  
    $('.menu').animate({
      scrollLeft: getMenuPosition() - ($('.menu').width()/2)
    }, scrollDuration);
  });

  });

  
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppe-featured-collections"] && !window.DesignMode) return;
  try {
    


if ($('.shoppe-fc').length > 0) {

    var loadedClass = $('.shoppe-fc-menu li').attr('class');
    $('.shoppe-fc-menu li').eq(0).addClass('active');      

    $('.shoppe-fc-products').each(function() {

        var crrnt = $(this);

        if (crrnt.hasClass(loadedClass)) {
            crrnt.addClass('show');
        }

        else {
            crrnt.removeClass('show');
        }
    });	





$('.shoppe-fc-menu li').on('click', function() {


        if (!$(this).hasClass('active')) {
          
            var clickedClass = $(this).attr('class');
            $('.shoppe-fc-menu li').removeClass('active');
            $(this).toggleClass('active');


            $('.shoppe-fc-products').each(function() {
                var crrnt = $(this);

                if (crrnt.hasClass(clickedClass)) {
                    crrnt.addClass('show');
                }

                else {
                    crrnt.removeClass('show');
                }
            });	

          
        }
    });
}




  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppe-menu"] && !window.DesignMode) return;
  try {
    

    // WINDOW SCROLL
    $(window).on('scroll', function(){

        scrollTop = $(window).scrollTop();

        if ($('.scrolling-header').width() > 0) {

            if ((scrollTop >= ($('.section-template--16078960525478__70646172-03fa-42df-9f01-30242c0e228f-padding').offset().top) - $('.scrolling-header').height())) {
                $('.scrolling-header').addClass('scrolling');
            }

            else {
                $('.scrolling-header').removeClass('scrolling');
            }
        }
        
    }); 

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppe-text"] && !window.DesignMode) return;
  try {
    

// WINDOW SCROLL
    $(window).on('scroll', function(){

        scrollTop = $(window).scrollTop();

        if ($('.scrolling-header').width() > 0) {

            if ((scrollTop >= ($('.shoppe-text').offset().top))) {
                $('.scrolling-header').addClass('scrolling');
            }

            else {
                $('.scrolling-header').removeClass('scrolling');
            }
        }
        
    }); 

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-section"] && !window.DesignMode) return;
  try {
    


  $('.name-wrapper img').on('click', function() {

        if (!$(this).hasClass('active')) {
            var clickedClass = $(this).attr('class');
            $('.name-wrapper img').removeClass('active');
            $(this).toggleClass('active');


            $('.team-bio-wrapper').each(function() {
                var crrnt = $(this);

                if (crrnt.hasClass(clickedClass)) {
                    crrnt.addClass('show');
                }

                else {
                    crrnt.removeClass('show');
                }
            });	

          $('.bio-close').on('click', function() {
            $('.team-bio-wrapper').removeClass('show');
          });
        }
    });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["terms"] && !window.DesignMode) return;
  try {
    


if ($('.customer-care-menu').length > 0) {
    
    var loadedClass = $('.customer-care-menu li').attr('class');
    $('.customer-care-menu li').eq(0).addClass('active');      

    $('.customer-care .right .menu-section').each(function() {

        var crrnt = $(this);

        if (crrnt.hasClass(loadedClass)) {
            crrnt.addClass('show');
        }

        else {
            crrnt.removeClass('show');
        }
    });	

    $('.customer-care-menu li').on('click', function() {

        if (!$(this).hasClass('active')) {
            var clickedClass = $(this).attr('class');
            $('.customer-care-menu li').removeClass('active');
            $(this).toggleClass('active');


            $('.customer-care .right .menu-section').each(function() {
                var crrnt = $(this);

                if (crrnt.hasClass(clickedClass)) {
                    crrnt.addClass('show');
                }

                else {
                    crrnt.removeClass('show');
                }
            });	
        }
    });
  }



  

  } catch(e) { console.error(e); }
})();

})();
